import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ScanOrderModalComponent } from '../scan-order-modal/scan-order-modal.component';
import { ScannableOrder } from '../../../../services/orders/scannable-order';
import { ApiService } from '../../../../core/services/api/api.service';
import { WindowService } from '../../../../core/services/window/window.service';

@Component({
  selector: 'app-mobile-order-details',
  templateUrl: './mobile-order-details.html',
  styleUrls: ['./mobile-order-details.scss'],
  standalone: false,
})
export class MobileOrderDetails implements OnInit {
  @Input() order: ScannableOrder;
  constructor(
    public dialogRef: MatDialogRef<ScanOrderModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private apiService: ApiService,
    private windowService: WindowService,
  ) {}

  ngOnInit() {
    this.order = this.data;
    this.updatePosition();
  }

  openBulkPrint(orderId: string) {
    this.windowService.openWindow(`${this.apiService.API_URL}label/labels/orders/${orderId}`);
  }

  updatePosition() {
    this.dialogRef.updateSize('400px', '80vh');
    this.dialogRef.updatePosition({ bottom: '0px' });
  }
}
